import { put } from 'redux-saga/effects';
import { getLocations } from '../../api/locationAPI';
import * as types from './locationActionTypes';

export function* getLocationSaga({ pageId }) {
  try {
    const location = yield getLocations(pageId);
    if (location && location.error) {
      yield put({
        type: types.GET_LOCATION_ERROR,
        error: location.error,
      });
    } else {
      yield put({
        type: types.GET_LOCATION_SUCCESS,
        location,
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_LOCATION_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/location/locationSaga.js